export default "__VITE_ASSET__CEuS2S7z__"